import { ChangeDetectionStrategy, HostListener, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TipoDoctoRef } from 'app/shared/inmemory-db/tipo-docto-ref';
import { Cadastro } from 'app/shared/interfaces/cadastro';
import { Cidade } from 'app/shared/interfaces/cidade';
import { FatDoctoRef } from 'app/shared/interfaces/fat-docto-ref';
import { PageResult } from 'app/shared/interfaces/page-result';
import { CadastroService } from 'app/shared/services/cadastro.service';
import { CidadeService } from 'app/shared/services/cidade.service';
import { FatDoctoCService } from 'app/shared/services/fat-docto-c.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { debounceTime, delay, filter, map, takeUntil, tap } from 'rxjs/operators';
import { FatDoctoC } from '../../../../../shared/interfaces/fat-docto-c';
import { AppConfirmService } from '../../../../../shared/services/app-confirm/app-confirm.service';

@Component({
  selector: 'app-lancamento-refer-popup',
  templateUrl: 'lancamento-refer-popup.component.html',
  styleUrls: ['lancamento-refer-popup.component.scss'],
})
export class LancamentoReferPopupComponent implements OnInit, OnDestroy {

  public doctoRefForm: FormGroup;

  ref: FatDoctoRef;

  maskUpper = {
    mask: /^\w\s*/,
    prepare: (str: any) => str.toUpperCase()
  };

  maskOnlyNumeric = {
    mask: '00000000000000000000000000000000000000000000',
    maxLength: 44,
    minLength: 44,
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };
  tipoDoctoRef: any;

  cadMun: Cidade;

  public searching = false;

  protected _onDestroy = new Subject<void>();

  filtroCidades: Cidade[] = [];
  cidades: Cidade[] = [];

  cadastros: Cadastro[] = [];
  cadastro: Cadastro;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<LancamentoReferPopupComponent>,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private confirmService: AppConfirmService,
    private fatDoctoCService: FatDoctoCService,
    private cidadeService: CidadeService,
    private cadastroService: CadastroService,
    private snack: MatSnackBar
  ) {
    this.tipoDoctoRef = new TipoDoctoRef().tipos;
  }

  ngOnInit() {
    this.ref = this.data.payload;
    this.buildProdutoPrecoForm(this.ref);
    this.cidades.push(this.ref.cadMun);
    if (this.ref.nfeRefCadCadastro !== undefined && this.ref.nfeRefCadCadastro !== null) {
      this.cadastros.push(this.ref.nfeRefCadCadastro);
    }

    /**
    * Search Cidades
    */
    this.doctoRefForm.get('searchCidade').valueChanges
      .pipe(
        filter(search => !!search),
        tap(() => this.searching = true),
        takeUntil(this._onDestroy),
        debounceTime(200),
        map(search => {
          if (!this.cidades) {
            return [];
          }
          return this.cidadeService.getCidadePageSearch(1, 10, search).subscribe(cidades => {
            this.cidades = cidades.content;
          });
        }),
        delay(200),
        takeUntil(this._onDestroy)
      )
      .subscribe(() => {
        this.searching = false;
        if (this.ref.cadMun !== undefined && this.ref.cadMun !== null) {
          if (this.cidades.map(n => n.id).includes(this.ref.cadMun.id)) {
            const cadMun = this.cidades.find(n => n.id === this.ref.cadMun.id) ?? this.ref.cadMun;
            if (cadMun !== null && cadMun !== undefined) {
              this.doctoRefForm.controls['cadMun'].setValue(cadMun);
            }
          } else {
            this.cidades.push(this.ref.cadMun);
          }
        }
      },
        error => {
          this.searching = false;
          this.confirmService.confirm(
            {
              message: `A T E N Ç Ã O !  ERRO PESQUISANDO CIDADES ... ${error}`,
              error: true
            });
        });
    // search searchNfeRefCadCadastro
    this.doctoRefForm.get('searchNfeRefCadCadastro').valueChanges
      .pipe(
        filter(search => !!search),
        tap(() => this.searching = true),
        takeUntil(this._onDestroy),
        debounceTime(200),
        map(search => {
          if (!this.cadastros) {
            return [];
          }
          return this.cadastroService.getCadastroPageSearch(1, 10, search + '').subscribe(destinatarios => {
            this.cadastros = destinatarios.content;
          });
        }),
        delay(200),
        takeUntil(this._onDestroy)
      )
      .subscribe(result => {
        this.searching = false;
        this.selectNfeRefCadCadastro();
      },
        error => {
          this.searching = false;
          this.confirmService.confirm(
            {
              message: `A T E N Ç Ã O !  ERRO PESQUISANDO DESTINATÁRIO ... ${error}`,
              error: true
            });
        });

      this.doctoRefForm.get('nfeRefChaveAcesso').valueChanges
      .pipe(
        filter(search => !!search),
        takeUntil(this._onDestroy),
        debounceTime(200),
        map(search => { 
          if (search.length === 44) {
            const tipo = search.substring(20, 22);
            if (tipo === '55' || tipo === '65')   {
              this.doctoRefForm.patchValue({ nfeRefDocumento: this.tipoDoctoRef[0]?.descricao });
            } else if (tipo === '57') {
              this.doctoRefForm.patchValue({ nfeRefDocumento: this.tipoDoctoRef[6]?.descricao });
            } else {
              this.doctoRefForm.patchValue({ nfeRefDocumento: this.tipoDoctoRef[0]?.descricao });
            }
          } else {
            this.doctoRefForm.patchValue({ nfeRefDocumento: this.tipoDoctoRef[0]?.descricao });

          }
        }
        ),
        takeUntil(this._onDestroy)
      ) 
      .subscribe(result => {
        this.searching = false;
      }
      );         
  }

  selectNfeRefCadCadastro() {
    if (this.doctoRefForm.get('nfeRefCadCadastro').value !== undefined && this.doctoRefForm.get('nfeRefCadCadastro').value !== null) {
      if (this.cadastros.map(n => n.id).includes(this.doctoRefForm.get('nfeRefCadCadastro').value.id)) {
        const cadastro = this.cadastros.find(n => n.id === this.doctoRefForm.get('nfeRefCadCadastro').value.id) ?? this.doctoRefForm.get('nfeRefCadCadastro').value;
        if (cadastro !== null && cadastro !== undefined) {
          this.doctoRefForm.controls['nfeRefCadCadastro'].setValue(cadastro);
        }
      } else {
        this.cadastros.push(this.doctoRefForm.get('nfeRefCadCadastro').value);
      }
    }

  }

  onSelectionChangeNfeRefCadCadastro(event) {
    this.doctoRefForm.controls['nfeRefCadCadastro'].setValue(event.value);
    this.doctoRefForm.controls['nfeRefCadCadastroId'].setValue(event.value?.id ?? null);
  }

  buildProdutoPrecoForm(ref: FatDoctoRef) {
    this.doctoRefForm = this.fb.group({
      id: [ref?.id],
      fatDoctoC: [ref?.fatDoctoC],
      nfeRefDocumento: [ref?.nfeRefDocumento],
      nfeRefChaveAcesso: [ref?.nfeRefChaveAcesso, Validators.required],
      nfeRefEmissao: [ref?.nfeRefEmissao],
      nfeRefCadCadastroId: [ref?.nfeRefCadCadastroId],
      nfeRefCadCadastro: [ref?.nfeRefCadCadastro],
      nfeRefNumeroDocto: [ref?.nfeRefNumeroDocto],
      nfeRefNumeroCoo: [ref?.nfeRefNumeroCoo],
      chaveNfe: [ref?.chaveNfe],
      cadMun: [ref?.cadMun],
      cadMunId: [ref?.cadMunId],
      nfeRefSerie: [ref?.nfeRefSerie],
      nfeRefModelo: [ref?.nfeRefModelo],
      cpfCnpjEmitente: [ref?.cpfCnpjEmitente],
      controle: [ref?.controle],
      uuid: [ref?.uuid],
      issueDate: [ref?.issueDate],
      updatedAt: [ref?.updatedAt],
      tipoDoctoRef: [ref?.tipoDoctoRef],
      searchCidade: '',
      searchNfeRefCadCadastro: ''
    })

  }

  save() {
    if (this.doctoRefForm.invalid) {
      this.snack.open('Campos obrigatórios não preenchidos, verifique!', 'ERRO', { verticalPosition: 'top', duration: 6500 });
      return;
    }
    this.fatDoctoCService.saveOrUpdateDoctoRef(this.doctoRefForm.value).subscribe(
      (precos) => {
        this.dialogRef.close();
        // this.confirmService.confirm(
        //   {
        //     title: `S U C E S S O  !`,
        //     message: `Docto Referenciado Atualizado com Sucesso !`,
        //     error: false
        //   }
        // );
      },
      (err) => {
        console.log(err);

        this.confirmService.confirm(
          {
            title: `A T E N Ç Ã O !`,
            message: `${err?.error.erro ?? 'Erro ao salvar Docto ref'}`,
            error: true
          }
        );
      });

  }

  onSelectionChange(event: any): void {
    this.cadMun = event.value;
    this.doctoRefForm.patchValue({ cadMunId: this.cadMun?.id ?? null });
  }


  ngOnDestroy() {
  }

  close() {
    this.dialogRef.close();
  }

}
